export default __webpack_public_path__ + "static/form-curves-4f41a5034809d0704b3b869b861300b1.svg";